import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from './Icons';
interface CTAButtonProps {
  text?: string;
  className?: string;
  onClick?: () => void;
  href?: string;
}
export function CTAButton({
  text = 'QUIERO MI ACCESO AHORA',
  className = '',
  onClick,
  href
}: CTAButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }
    if (href) {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'AddToCart');
      }
      window.open(href, '_blank');
      return;
    }
    const pricingArea = document.getElementById('pricing-area');
    if (pricingArea) {
      pricingArea.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`group relative inline-flex items-center justify-center gap-3 bg-gold hover:bg-gold-light text-dark font-bold text-lg md:text-xl py-4 px-8 rounded-sm shadow-[0_0_20px_rgba(197,165,90,0.3)] hover:shadow-[0_0_30px_rgba(197,165,90,0.6)] transition-all duration-300 ${className}`} data-id="element-40">
      <span data-id="element-41">{text}</span>
      <ArrowRightIcon className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-42" />
    </motion.button>;
}